var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.875,
    y: 4.875,
    width: 4,
    height: 4,
    stroke: "#F59D0E",
    strokeWidth: 1.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.875,
    y: 13.125,
    width: 4,
    height: 4,
    stroke: "#F59D0E",
    strokeWidth: 1.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.125,
    y: 4.875,
    width: 4,
    height: 4,
    stroke: "#F59D0E",
    strokeWidth: 1.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6529,
    y: 14.6527,
    width: 0.944428,
    height: 0.944428,
    fill: "#F59D0E",
    stroke: "#F59D0E",
    strokeWidth: 0.888873
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16.4859,
    y: 12.8194,
    width: 0.944428,
    height: 0.944428,
    fill: "#F59D0E",
    stroke: "#F59D0E",
    strokeWidth: 0.888873
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 16.4859,
    y: 16.4862,
    width: 0.944428,
    height: 0.944428,
    fill: "#F59D0E",
    stroke: "#F59D0E",
    strokeWidth: 0.888873
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8194,
    y: 16.4862,
    width: 0.944428,
    height: 0.944428,
    fill: "#F59D0E",
    stroke: "#F59D0E",
    strokeWidth: 0.888873
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8194,
    y: 12.8194,
    width: 0.944428,
    height: 0.944428,
    fill: "#F59D0E",
    stroke: "#F59D0E",
    strokeWidth: 0.888873
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.0625 7.16964V2.0625H7.16964M7.16964 19.9375H2.0625V14.8304M19.9375 14.8304V19.9375H14.8304M14.8304 2.0625H19.9375V7.16964",
    stroke: "#F59D0E",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/QR.f3d1b0fd12f544a976bbf6c6e5872bdd.svg";
export { ForwardRef as ReactComponent };